function updateWarehouseVariant(variant) {
  if (!variant || !variant.featured_media) return;

  const gallery = document.querySelector(".product-gallery__carousel");
  if (!gallery) return;

  // Find all media elements (skip promo in logic but keep visible)
  const slides = Array.from(gallery.querySelectorAll("[data-media-id]"));
  const promoSlide = slides[0];
  const variantSlides = slides.slice(1);
  const mediaId = variant.featured_media.id;

  console.log("🎯 Target media ID:", mediaId);

  // Find matching slide by ID or src
  let match = variantSlides.find((s) => s.dataset.mediaId == mediaId);
  if (!match && variant.featured_media.preview_image) {
    const targetSrc = variant.featured_media.preview_image.src.split("?")[0];
    match = variantSlides.find((s) => {
      const img = s.querySelector("img");
      return img && img.src.includes(targetSrc);
    });
  }

  if (match) {
    // Reset all slides except promo
    variantSlides.forEach((s) => {
      s.classList.remove("is-selected");
      s.style.opacity = "0";
      s.style.zIndex = "0";
      s.setAttribute("aria-hidden", "true");
    });

    // Ensure promo image stays visible in background
    promoSlide.style.opacity = "1";
    promoSlide.style.zIndex = "0";
    promoSlide.setAttribute("aria-hidden", "false");

    // Activate correct variant image
    match.classList.add("is-selected");
    match.style.opacity = "1";
    match.style.zIndex = "1";
    match.removeAttribute("aria-hidden");

    // Manually scroll Flickity if active
    if (gallery.flickityInstance) {
      const index = slides.indexOf(match);
      gallery.flickityInstance.select(index);
    }

    console.log("✅ Switched to variant image:", mediaId);
  } else {
    console.warn("⚠️ No match for variant media:", mediaId);
  }
}
